import React, { useEffect } from 'react';
import house from '../../images/Capture1.PNG'
import Aos from 'aos';
import 'aos/dist/aos.css';

const BuyingHouse = () => {
    useEffect(() => {
        Aos.init()
    })
    return (
        <div 
        data-aos="zoom-in"
        data-aos-duration="3000"
        className="bg-gray-300 ">
           <h1 className="text-4xl font-semibold text-red-500">Buying House</h1>
           <div className="grid lg:grid-cols-3 px-5 mt-3">
               <div >
                   <img className="px-3" src={house} alt="" />
               </div>
               <div>
                   <img className="px-3" src="https://i.ibb.co/WB6sfbR/buy-user.png" alt="" />
               </div>
               <div>
                   <img className="px-3" src="https://i.ibb.co/rZqgyDM/buy-admin.png" alt="" />
               </div>
           </div>

           <div className="mt-10">
               
               <p className="text-justify text-xl px-10  mb-5"> A full-stack single-page property selling web app where people can take and book properties. Login system with firebase and private routes. Dashboard for users and admins where admins can do CRUD operations and users can give reviews and monitor their booking list. </p>
               
               <button className="px-2 py-1 bg-gray-400 ">React.js</button> 
        <button className="px-2 py-1 bg-gray-400 mx-1">React Tailwind</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Node.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Express.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">MongoDB</button>
        <button className="px-2 py-1 bg-gray-400 mx-1 mt-1">Firebase Authentication</button>
           </div>

           <div className="mt-5 pb-10"> 
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://buying-house-6d184.web.app/">Live Preview</a> </button>
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://github.com/Joy10311/Buying_House_Client">Client Code</a> </button>
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl my-2 mx-2"> <a href="https://github.com/Joy10311/Buying_House_Server">Server Code</a> </button>
           </div>
        </div>
    );
};

export default BuyingHouse;
